import $API from "@/services";
import { setLocale } from "@vee-validate/i18n";
import Cookies from "js-cookie";

function isKorean(locale: string) {
  return locale === "ko" || locale.startsWith("ko-");
}
function isJapanese(locale: string) {
  return locale === "ja" || locale.startsWith("ja-");
}

function isUzbek(locale: string) {
  return locale === "uz" || locale.startsWith("uz-");
}
function isRussian(locale: string) {
  return locale === "ru" || locale.startsWith("ru-");
}

function getLocale() {
  let cookieLocale = Cookies.get("user-locale") ?? "";
  if (cookieLocale.length > 0) {
    if (cookieLocale.indexOf("-") > 0) {
      cookieLocale = cookieLocale.substring(0, 2);
    }
  }
  let locale = cookieLocale || navigator.language || process.env.VUE_APP_I18N_LOCALE || "en";
  if (locale.indexOf("-") > 0) {
    locale = locale.substring(0, 2);
  }
  return locale;
}

function initLocale() {
  const cookieLocale = getLocale();

  setLocale(cookieLocale);

  const language =
    cookieLocale === "en"
      ? "en-us"
      : cookieLocale === "ko"
      ? "ko-kr"
      : cookieLocale === "ja"
      ? "ja-jp"
      : cookieLocale === "uz"
      ? "uz-uz"
      : cookieLocale === "ru"
      ? "ru-ru"
      : "en-us";

  $API.AccountsService.setLanguage(language);

  return cookieLocale;
}

export default { initLocale, getLocale, isKorean, isJapanese, isUzbek, isRussian };
